import { createLucideIcon } from "lucide-react-native";
import type { ComponentProps } from "react";
import { ClipPath, Defs, Path, Use } from "react-native-svg";

const GOOGLE_TRANSFORM = "matrix(.54545 0 0 .54545 -.71625 -1.09125)";

const GoogleIconBase = createLucideIcon("GoogleIcon", []);

const GoogleIcon = (props: ComponentProps<typeof GoogleIconBase>) => (
  <GoogleIconBase {...props}>
    <Defs>
      <Path
        id="google-g"
        d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z"
      />
    </Defs>
    <ClipPath id="google-clip">
      <Use xlinkHref="#google-g" />
    </ClipPath>
    <Path
      d="M0 37V11l17 13z"
      clipPath="url(#google-clip)"
      fill="#fbbc05"
      transform={GOOGLE_TRANSFORM}
      key="yellow"
    />
    <Path
      d="M0 11l17 13 7-6.1L48 14V0H0z"
      clipPath="url(#google-clip)"
      fill="#ea4335"
      transform={GOOGLE_TRANSFORM}
      key="red"
    />
    <Path
      d="M0 37l30-23 7.9 1L48 0v48H0z"
      clipPath="url(#google-clip)"
      fill="#34a853"
      transform={GOOGLE_TRANSFORM}
      key="green"
    />
    <Path
      d="M48 48L17 24l-4-3 35-10z"
      clipPath="url(#google-clip)"
      fill="#4285f4"
      transform={GOOGLE_TRANSFORM}
      key="blue"
    />
  </GoogleIconBase>
);

export default GoogleIcon;
